import { useSelector } from "react-redux";
import { CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, Fragment, useState, useMemo } from "react";

import { Autocomplete, Label, TextField } from "../../../../components";
import { colors, HeadingEighteen } from "../../../css components/Style";
import useAxiosCustomToken from "../../../../hooks/useAxiosCustomToken";
import { generateAsymmetricToken } from "../../../../utils/encryptPyToken";

export default function FormEighth({
  smsAgents,
  smsServiceAgents,
  agents,
  formikProps,
  editState,
  setSmsServiceAgents,
  setAgents,
}) {
  const [message, setMesssage] = useState("");
  const [loading, setLoading] = useState(false);
  const [smsTemplates, setSMSTemplates] = useState([]);
  const [templateDetails, setTemplateDetails] = useState([]);

  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );
  const x_sso_token = sessionStorage.getItem("ida_sso_login");

  const axios = useAxiosCustomToken({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  const reversedAgents = useMemo(() => {
    const agentList = Array.isArray(agents) ? agents : agents?.Whatsapp || [];

    return [...agentList].reverse();
  }, [agents]);

  useEffect(() => {
    if (formikProps.values.campaignID) {
      axios({
        url: "/bot/agents",
        method: "post",
        data: {},
        disableRedirect: true,
        params: {
          brand_id: formikProps.values.brandID,
          channel_id: formikProps.values.pref_campaign_channel.value,
          ...(Boolean(
            formikProps.values.pref_campaign_channel.value === 15
          ) && {
            service: "bsa",
          }),
        },
        customAuthToken:
          x_sso_token !== null ? authToken : "Bearer " + accessToken,
      }).then((res) => {
        if (res.status) {
          if (formikProps.values.pref_campaign_channel.value === 15) {
            axios({
              url: `/bot/agents?brand_id=${formikProps.values.brandID}&channel_id=${formikProps.values.pref_campaign_channel.value}&service=indosat`,
              data: {},
              method: "post",
              disableRedirect: true,
              customAuthToken:
                x_sso_token !== null ? authToken : "Bearer " + accessToken,
            }).then((response) => {
              if (response.status) {
                setSmsServiceAgents(response.data);
              }
            });

            axios({
              url:
                "/wa/template/sms-template/" +
                formikProps.values.sms_agent_id.value,
              method: "GET",
              disableRedirect: true,
              customAuthToken:
                x_sso_token !== null ? authToken : "Bearer " + accessToken,
            }).then((response) => {
              if (response.status && response.data.length > 0) {
                setSMSTemplates(response.data);
                setMesssage("");
              }
            });
          }

          if (formikProps.values.pref_campaign_channel.value === 1) {
            let token = accessToken || formikProps.values.agentToken;

            axios({
              url:
                "/bot/bot-template-details/" +
                formikProps.values?.whatsapp_agent?.value,
              method: "GET",
              disableRedirect: true,
              customAuthToken:
                x_sso_token !== null ? authToken : "Bearer " + token,
            }).then((response) => {
              if (response.status) {
                setTemplateDetails(response.data);
              }
            });
          }

          setAgents(res.data);
        }
      });
    }
  }, [
    axios,
    agents.Whatsapp,
    authToken,
    formikProps.values.agentToken,
    accessToken,
    formikProps.values.brandID,
    formikProps.values.campaignID,
  ]);

  async function handleChangeAgent(value, type, name, primaryKey) {
    let token = accessToken || formikProps.values.agentToken;

    if (type === "selectOption") {
      await formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: {
          value: value[primaryKey],
        },
      }));

      if (name === "whatsapp_agent") {
        setLoading(true);
        setTemplateDetails([]);
        formikProps.setValues((prevVal) => ({
          ...prevVal,
          whatsapp_template: { value: "" },
        }));
        axios({
          url: "/bot/bot-template-details/" + value.agent_id,
          method: "GET",
          disableRedirect: true,
          customAuthToken: "Bearer " + token,
        }).then((response) => {
          if (response.status && response.data.length > 0) {
            setTemplateDetails(response.data);

            setMesssage("");
          } else {
            setTemplateDetails([]);
            setLoading(false);
            setMesssage(response.message?.displayMessage);
          }
        });
      }

      if (name === "sms_agent_id") {
        axios({
          url: "/wa/template/sms-template/" + value.agent_id,
          method: "GET",
          disableRedirect: true,
          customAuthToken: "Bearer " + token,
        }).then((response) => {
          if (response.status && response.data.length > 0) {
            setSMSTemplates(response.data);
            setMesssage("");
          } else {
            formikProps.setValues((prevVal) => ({
              ...prevVal,
              sms_template_id: { value: "" },
            }));
            setSMSTemplates([]);
            setMesssage(response.message?.displayMessage);
          }
        });
      }
    } else {
      value = {
        value: "",
        label: "",
      };
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: {
          value: value.label,
        },
      }));
    }
  }

  return (
    <Fragment>
      {!!formikProps.values?.pref_campaign_channel?.value &&
        formikProps.values.pref_campaign_channel.value === 1 && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Whatsapp Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Select WhatsApp Agent"}
                formikProps={formikProps}
                required={true}
                name="whatsapp_agent.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="whatsapp_agent.value"
                placeholder="Select WhatsApp Agent"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={reversedAgents}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "whatsapp_agent", "agent_id")
                }
                formikProps={formikProps}
              />

              <Typography
                style={{
                  fontSize: "13px",
                  color: colors.error,
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {message}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Label
                title="Select WhatsApp Template"
                formikProps={formikProps}
                required={true}
                name="whatsapp_template.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="whatsapp_template.value"
                loading={loading}
                placeholder="Select WhatsApp Template"
                defaults={{
                  primaryKey: "_id",
                  displayLabel: "name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={templateDetails}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "whatsapp_template", "_id")
                }
                formikProps={formikProps}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? <CircularProgress size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Fragment>
        )}

      {!!formikProps.values?.pref_campaign_channel?.value &&
        formikProps.values.pref_campaign_channel.value === 15 && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>SMS Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Select SMS Indosat Agent"}
                formikProps={formikProps}
                required={true}
                name="sms_agent_id.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="sms_agent_id.value"
                placeholder="Select SMS Indosat Agent"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={smsServiceAgents}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "sms_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />

              <Typography
                style={{
                  fontSize: "13px",
                  color: colors.error,
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {message}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Label
                title="Select SMS Template"
                formikProps={formikProps}
                required={true}
                name="sms_template_id.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="sms_template_id.value"
                placeholder="Select SMS Template"
                defaults={{
                  primaryKey: "template_id",
                  displayLabel: "template_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={smsTemplates}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(
                    value,
                    type,
                    "sms_template_id",
                    "template_id"
                  )
                }
                formikProps={formikProps}
              />
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Select SMS Agent"}
                formikProps={formikProps}
                required={true}
                name="sms_bsa_agent_id.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="sms_bsa_agent_id.value"
                placeholder="Select SMS Indosat Agent"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={reversedAgents}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "sms_bsa_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />

              <Typography
                style={{
                  fontSize: "13px",
                  color: colors.error,
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {message}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Label
                title="Enter SMS Template"
                formikProps={formikProps}
                required={true}
                name="sms_bsa_text_msg.value"
              />

              <TextField
                name="sms_bsa_text_msg.value"
                placeholder="Enter SMS Template"
                multiline
                disabled={!editState}
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}

      {!!formikProps.values?.pref_campaign_channel?.value &&
        formikProps.values.pref_campaign_channel.value === 3 && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Meta Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Meta Agent Details"}
                formikProps={formikProps}
                required={true}
                name="meta_agent_id.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="meta_agent_id.value"
                placeholder="Meta Agent Details"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={reversedAgents}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "meta_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}

      {!!formikProps.values?.pref_campaign_channel?.value &&
        formikProps.values.pref_campaign_channel.value === 5 && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Google Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Google Agent Details"}
                formikProps={formikProps}
                required={true}
                name="google_agent_id.value"
              />

              <Autocomplete
                forcePopupIcon={!editState ? false : true}
                name="google_agent_id.value"
                placeholder="Google Agent Details"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={reversedAgents}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "google_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}
    </Fragment>
  );
}
